import SetupTemplate from "./SetupTemplate";
import Container from "@mui/material/Container";
import BackButton from "../../common/back-button";
import { Box } from "@mui/material";

const CreateTemplate = (props) => {
  const { templatesNamesData, setComponent } = props;

  return (
    <div className="App">
      <Container maxWidth={false}>
        <Box sx={{ pt: 2}}>
          <BackButton
            onClick={() => props.onNavigate("view_templates")}
            sx={{ mt: 3 }}
          />
        </Box>
        <SetupTemplate
          key={props.refreshKey}
          onNavigate={props.onNavigate}
          templatesNamesData={templatesNamesData}
          setComponent={setComponent}
        />
      </Container>
    </div>
  );
};
export default CreateTemplate;
